import { FC } from "react";
// import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";
import AnimatedIconSpinningCoin from "../icons/animated/AnimatedIconSpinningCoin";

interface PointIconLoaderProps {
    className?: string;
    loaderText?: string;
    loaderClassname?: string;
    loaderTextClassname?: string;
    customLoaderText?: React.ReactNode;
}

const PointIconLoader: FC<PointIconLoaderProps> = ({ className, loaderText, /* loaderClassname, */ loaderTextClassname, customLoaderText }) => {
    return (
        <div
            className={
                cn(
                    "text-primary-color min-h-[200px] flex flex-col justify-center items-center",
                    className
                )
            }
        >
            {/* 
            // TODO: REMOVE
            */}
            {/* <Loader2
                className={
                    cn(
                        "h-10 w-10 animate-spin",
                        loaderClassname
                    )
                }

            /> */}
            <AnimatedIconSpinningCoin className="w-32 h-32 lg:w-36 lg:h-36" coinSize="h-12 w-12 lg:h-16 lg:w-16" coinIconSize="h-6 w-6 lg:h-9 lg:w-9" />
            {customLoaderText ||
                <h2
                    className={
                        cn(
                            "mt-3 text-lg text-primary-color text-center",
                            loaderTextClassname
                        )
                    }
                >
                    {loaderText || "Please wait"}...
                </h2>
            }
        </div>
    );
};

export default PointIconLoader; 